<template>
  <div
    class="border-t border-gray-700 px-4 pb-12 pt-6 xs:border-t-0 md:border-t md:px-0 md:pb-16"
  >
    <h3 class="mb-7 text-xl font-medium text-anthracite-300">
      {{ $t('footer.promises.top_categories') }}
    </h3>
    <div
      class="grid grid-cols-2 gap-x-10 gap-y-6 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4"
    >
      <div
        v-for="(column, colIdx) in categories"
        :key="`cat-col-${colIdx}`"
        class="space-y-2"
      >
        <template v-for="item in column.children" :key="item.id">
          <NuxtLink
            :to="getItemRoute(item)"
            class="block text-lg font-normal leading-[28px] text-anthracite-300 hover:text-orange-500 md:text-md md:leading-[28px]"
          >
            {{ item.name }}
          </NuxtLink>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { NavigationTreeItem } from '@scayle/storefront-nuxt'
import { NuxtLink } from '#components'
import { useRouteHelpers } from '~/composables'

const { buildNavigationTreeItemRoute, getLocalizedRoute } = useRouteHelpers()

defineProps<{
  categories: NavigationTreeItem[]
}>()

const getItemRoute = (item: NavigationTreeItem) => {
  const pathParams = buildNavigationTreeItemRoute(item)
  return pathParams?.route ? getLocalizedRoute(pathParams?.route) : '#'
}
</script>

<script lang="ts">
export default {
  name: 'SFFooterCategories',
}
</script>
